import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentCourseRepeatRateGauge from './ContentCourseRepeatRateGauge';
import { ContentCourseRepeatRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentCourseRepeatRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentCourseRepeatRateListService.load();
  }
  render() {
    const data = ContentCourseRepeatRateListService.getChart();
    return (
      <ContentCourseRepeatRateGauge
        loading={
          ContentCourseRepeatRateListService.fetchCurrent.fetching ||
          ContentCourseRepeatRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentCourseRepeatRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('UNIT_ITEM_EXECUTION_REPEAT_RATE')}
      />
    );
  }
}

export default observer(ContentCourseRepeatRateGaugeContainer);
